<main class="main-wrap">
    <div class="wrapper">
      <div class="coming-soon-bg">
          <div class="center-logo">
              <a href="#">
                  <img src="assets/images/login-logo.svg" alt="logo">
              </a>
          </div>
          <div class="coming-soon-content">
              <strong>coming soon</strong>
              <span>Beauty Solutions <i>made simple just</i> for you</span>
          </div>
      </div>
    </div>
</main>